import React from 'react';

import PropTypes from 'prop-types';

import { localize } from 'wanderu-i18n';

import {
    OUTLINE_RADIUS,
    TOOLTIP_BORDER_RADIUS,
    TOOLTIP_DISTANCE,
    TOOLTIP_HEIGHT,
    TOOLTIP_WIDTH,
    TOOLTIP_TEXT_HEIGHT,
    TOOLTIP_SUB_TEXT_HEIGHT,
} from '../constants';

import styles from './Tooltip.scss';

const propTypes = {
    data: PropTypes.shape({
        xPos: PropTypes.number.isRequired,
        xVal: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]).isRequired,
        yPos: PropTypes.number.isRequired,
        yVal: PropTypes.number.isRequired,
    }).isRequired,
    chartType: PropTypes.string.isRequired,
    containerWidth: PropTypes.number.isRequired,
    dataType: PropTypes.string.isRequired,
};

function Tooltip(props) {
    const {
        t,
        i18nMoment,
        i18nMoney,
        containerWidth,
        chartType,
        data,
        dataType,
    } = props;
    const {
        xPos,
        xVal,
        yPos,
        yVal,
    } = data;

    const showMonth = chartType === 'bar' && typeof xVal === 'number';
    const showDate = chartType === 'bar' && typeof xVal === 'string';
    const isLineGraph = chartType === 'line' || chartType === 'curve';

    const tooltipBaseOffset = TOOLTIP_HEIGHT + TOOLTIP_DISTANCE;
    const tooltipOffset = isLineGraph
        ? tooltipBaseOffset + OUTLINE_RADIUS
        : tooltipBaseOffset;

    let tooltipXPosition = isLineGraph
        ? xPos - TOOLTIP_WIDTH / 2
        : xPos - TOOLTIP_WIDTH / 4;

    let tooltipYPosition = isLineGraph
        ? yPos + TOOLTIP_HEIGHT / 2
        : 0;

    if (xPos + TOOLTIP_WIDTH > containerWidth) {
        tooltipXPosition = containerWidth - TOOLTIP_WIDTH;
    }

    if (yPos - tooltipOffset > 0) {
        tooltipYPosition = yPos - tooltipOffset;
    }

    return (
        <g>
            <rect
                className={styles.tooltipContainer}
                height={TOOLTIP_HEIGHT}
                rx={TOOLTIP_BORDER_RADIUS}
                width={TOOLTIP_WIDTH}
                x={tooltipXPosition}
                y={tooltipYPosition}
            />
            <text
                className={styles.tooltipText}
                x={tooltipXPosition + TOOLTIP_WIDTH / 2}
                y={tooltipYPosition + TOOLTIP_TEXT_HEIGHT}
            >
                {dataType === 'price'
                    ? i18nMoney(yVal).format({
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                    })
                    : yVal}
            </text>
            <text
                className={styles.tooltipSubText}
                x={tooltipXPosition + TOOLTIP_WIDTH / 2}
                y={tooltipYPosition + TOOLTIP_SUB_TEXT_HEIGHT}
            >
                {showMonth && i18nMoment(xVal, 'M').format('MMM')}
                {showDate && i18nMoment(xVal).format('ll').split(',')[0]}
                {isLineGraph && t.plural('days-until', xVal, {
                    from: xVal,
                })}
            </text>
        </g>
    );
}

Tooltip.propTypes = propTypes;

export { Tooltip };
export default localize(Tooltip, 'baseApp');
